import React from 'react';
import styles from './Studio.module.scss';

import { Badge } from '@eventbrite/legacy-eds.badge';
import { gettext } from '@eventbrite/legacy-infra.i18n';

// NOTE: "Studio" is the product name and therefore is intentionally not translated below
export const Studio = () => (
    <div>
        <span>Studio</span>
        <span className={styles.containerSpacing}>
            <Badge text={gettext('New').toString()} bgColor="success" />
        </span>
    </div>
);
